import React, { useState } from 'react';

type FallingImageProp = {
    isFalling: boolean
    setIsFalling: (value: boolean) => void;
    onLetterClick: (letter: string) => void;
}

const GreekTileGrid: React.FC<FallingImageProp> = ({isFalling, setIsFalling, onLetterClick}) => {
    const greekLetters = ['Α', 'Β', 'Γ', 'Δ', 'Ε', 'Ζ', 'Η', 'Θ', 'Ι', 'Κ', 'Λ', 'Μ', 'Ν', 'Ξ', 'Ο', 'Π', 'Ρ', 'Σ', 'Τ', 'Υ', 'Φ', 'Χ', 'Ψ', 'Ω'];

    const [lastClicked, setLastClicked] = useState<string | null>(null);

    const handleTileClick = (letter: string) => {
        if (!isFalling) {  // Only allow click if not currently falling
            setLastClicked(letter);
            setIsFalling(true);  // Set to true instead of toggling
            onLetterClick(letter);
        }
    };

    const buttonClasses = `
        aspect-[1.5/1]
        flex items-center justify-center
        rounded
        transition-colors
        text-white text-sm md:text-base
        font-medium
        ${isFalling ? 
            'bg-white/5 cursor-not-allowed opacity-50' : 
            'bg-white/10 hover:bg-white/20 cursor-pointer active:bg-white/30'
        }
    `;

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 w-full max-w-[800px] min-w-[280px] px-4 z-50">
            <div className="bg-slate-800/90 rounded-lg p-2 backdrop-blur-sm">
                <div className="grid grid-rows-2 gap-1">
                    {/* Row 1 */}
                    <div className="grid grid-cols-12 gap-1">
                        {greekLetters.slice(0, 12).map((letter, index) => (
                            <button
                                key={index}
                                onClick={() => handleTileClick(letter)}
                                disabled={isFalling}
                                className={buttonClasses}
                
                            >
                                {letter}
                            </button>
                        ))}
                    </div>
                    {/* Row 2 */}
                    <div className="grid grid-cols-12 gap-1">
                        {greekLetters.slice(12).map((letter, index) => (
                            <button
                                key={index + 12}
                                onClick={() => handleTileClick(letter)}
                                disabled={isFalling}
                                className={buttonClasses}
                            >
                                {letter}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GreekTileGrid;